import React from 'react';
import ReactDOM from 'react-dom/client';
import MiniApp from './MiniApp.tsx';
import './globalStylesMiniApp.css';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <MiniApp />
  </React.StrictMode>
);
